import { appSessionStorage } from '@utils/storageUtils'
import { useState } from 'react'

import type { DropdownFilters } from '@suntex.fim/assessment'
import { defaultDropdownFilter } from '@suntex.fim/assessment'
import { $SpecialGradeLevel, SpecialGradeLevel } from '@suntex.fim/enums'
import { useAppQueryString } from '@suntex.fim/nav'

export type { DropdownFilters }
export { defaultDropdownFilter }

export function useAssessmentDropdownFilters(): [
  DropdownFilters,
  (filters: DropdownFilters) => void
] {
  const { grade, year } = useAppQueryString()
  const [dropdownFilters, setDropDownFilters] = useState<DropdownFilters>(
    () => {
      return {
        grade: $SpecialGradeLevel.from(
          grade ?? appSessionStorage.assessmentGrade
        ),
        year: year ?? appSessionStorage.schoolYear
      }
    }
  )

  return [
    dropdownFilters,
    (filters) => {
      appSessionStorage.schoolYear = filters.year || ''
      appSessionStorage.assessmentGrade =
        filters.grade || SpecialGradeLevel.Kindergarten
      setDropDownFilters(filters)
    }
  ]
}
